import React, { useState } from "react"
import { graphql, useStaticQuery } from "gatsby"
import Icon from "../../../../blocks/icon/Icon"

import Select, { components } from "react-select"

function ContractSearchField({
  contractFilter,
  setContractFilter,
  setShowContractField,
}) {
  const { DropdownIndicator } = components;

  const data = useStaticQuery(
    graphql`
      {
        strapi {
          jobAdCriterias(
            filters: { type: { eq: "Type de contrat" } }
            pagination: { limit: 100 }
          ) {
            data {
              attributes {
                key
                value
                type
              }
            }
          }
        }
      }
    `
  )
  const contractTypeList = data.strapi.jobAdCriterias.data

  const options = contractTypeList.map((c) => {
    return { value: c.attributes.key, label: c.attributes.value }
  })

  const customStyles = {
    control: (baseStyles, state) => ({
      display: "flex",
      background: "var(--input-background-color)",
      borderRadius: "var(--border-radius)",
      cursor: "pointer",
    }),
    valueContainer: (provided, state) => ({
      // fontSize: '1px',
      //color: 'white',
      textOverflow: "ellipsis",
      //whiteSpace: "nowrap",
      overflow: "hidden",
      display: "flex",
      width: "100%",
      paddingBlock: "16px",
      paddingLeft: "24px",
    }),
    indicatorContainer: (provided, state) => ({
      ...provided,
      paddingInline: "24px",
    }),
  }

  const classNames = {
    container: (state) => "form-control",
  }

  const dropdownIndicator = (props) => {
    return (
      <DropdownIndicator
        className="pin-3"
        {...props}
      >
        <Icon
          icon="search"
          color="var(--gris)"
          width="22"
          height="22"
        />
      </DropdownIndicator>
    )
  }

  const multiValueContainer = ({ selectProps, data }) => {
    const label = data.label
    const allSelected = selectProps.value
    const index = allSelected.findIndex((selected) => selected.label === label)
    const isLastSelected = index === allSelected.length - 1
    const labelSuffix = isLastSelected ? `` : ", "
    const val = `${label}${labelSuffix}`
    return index === 0 ? "CDI.." : ""
  }

  const [menuIsOpen, setMenuIsOpen] = useState(false)

  const handleMenuClose = () => {
    if (setShowContractField) {
      setMenuIsOpen(false)
      setShowContractField(false)
    }
  }

  return (
    <Select
      isMulti={true}
      options={options}
      closeMenuOnSelect={false}
      hideSelectedOptions={false}
      value={contractFilter}
      onChange={setContractFilter}
      placeholder={"CDI.."}
      components={{
        MultiValueContainer: multiValueContainer,
        DropdownIndicator: dropdownIndicator,
        IndicatorSeparator: () => null,
        // Option: CustomOption,
      }}
      styles={customStyles}
      isSearchable={false}
      onMenuOpen={() => setMenuIsOpen(true)}
      onMenuClose={handleMenuClose}
    />
  )
}

export default ContractSearchField
